module.exports = __webpack_public_path__ + "img/logo@3x.9cad8e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo@3x.png
// module id = oG2R
// module chunks = 3